<cvc-entity-select
  [cvcAddEntity]="addDisease"
  [cvcSelectMode]="props.isMultiSelect ? 'multiple' : 'default'"
  [cvcCustomTemplate]="selectedTemplate"
  [cvcFormControl]="formControl"
  [cvcFormlyAttributes]="field"
  [cvcEntityName]="props.entityName"
  [cvcPlaceholder]="placeholder$ | ngrxPush"
  [cvcResults]="result$ | ngrxPush"
  [cvcOptions]="selectOption$ | ngrxPush"
  [cvcShowError]="showError"
  [cvcDisabled]="onRequiresDisease$ && !(onRequiresDisease$ | ngrxPush)"
  [cvcLoading]="isLoading$ | ngrxPush"
  [cvcSelectOpen]="selectOpen$ | ngrxPush"
  (cvcOnSearch)="onSearch$.next($event)"
  (cvcOnOpenChange)="onOpenChange$ ? onOpenChange$.next($event) : null"
  (cvcSelectComponent)="selectComponent = $event"
  (cvcOnModelChange)="props.change && props.change(field, $event)">
</cvc-entity-select>

<!-- select option templates -->
<!-- each search result$ creates an individual template, which is
    dynamically attached to an NzSelectOptionTemplateInterface object in
    optionTemplates.changes.subscribe()-->
<ng-container *ngrxLet="onSearch$ as searchString">
  <ng-container *ngFor="let result of result$ | ngrxPush; index as i">
    <ng-template #optionTemplates>
      <cvc-entity-tag
        [cvcDisableLink]="true"
        [cvcCacheId]="result.__typename + ':' + result.id"
        [cvcEmphasize]="searchString"></cvc-entity-tag>
      <span
        nz-typography
        nzType="secondary">
        <ng-container *ngIf="result.doid">
          <strong>DOID:</strong>
          <span
            [innerHtml]="
              result.doid | highlightTypeahead : searchString
            "></span>
        </ng-container>
        <ng-container *ngIf="result.diseaseAliases.length > 0">
          &nbsp;
          <strong>Aliases: </strong>
          <em>
            <span
              nz-typography
              nzType="secondary"
              nz-tooltip
              [nzTooltipTitle]="result.diseaseAliases.join(', ')"
              [innerHtml]="
                result.diseaseAliases.join(', ')
                  | highlightTypeahead : searchString
              "></span
          ></em>
        </ng-container>
        {{ searchString }}
      </span>
    </ng-template>
  </ng-container>
</ng-container>

<!-- selected option item template -->
<!-- displays entity tag, specifying context and mode depending on
    if field is multi-select or single -->
<ng-template
  #selectedTemplate
  let-selected>
  <div class="ant-select-selection-item-content">
    <cvc-entity-tag
      [cvcCacheId]="'Disease:' + selected.nzValue"
      [cvcContext]="props.isMultiSelect ? 'multi-select-item' : 'select-item'"
      [cvcMode]="props.isMultiSelect ? 'default' : 'closeable'"
      (cvcOnClose)="onTagClose$.next(selected.nzValue)"></cvc-entity-tag>
  </div>
</ng-template>

<!-- quick-add form template-->
<ng-template
  #addDisease
  let-searchStr
  let-createMsg>
  <cvc-disease-quick-add-form
    [cvcSearchString]="searchStr"
    (cvcOnCreate)="onPopulate$.next($event)">
  </cvc-disease-quick-add-form>
</ng-template>
